import React from 'react';
import { motion } from 'framer-motion';
import icon_a from "../assets/check.png";
import toy_train from "../assets/toy-train.png";
import advance_jackpot from "../assets/home-grand.png";
import "../css/style.css";

const JackpotSystems = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-white lg:py-20 px-4 md:px-24"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 sm:gap-36">
          {/* Left Content */}
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
            className="mt-7"
          >
            <h2 className="text-2xl sm:text-3xl md:text-[2.6rem] lg:text-start whitespace-nowrap font-bold mb-6 text-black">
              Advanced Jackpot Systems
            </h2>
            <p className="text-[14px] md:text-[18px] lg:text-base text-gray-500 text-justify poppins-font2 leading-relaxed lg:pb-4 md:pb-4">
              We offer multiple jackpot options that significantly enhance the player experience and operator flexibility:
            </p>

            {/* Image for medium screens only */}
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1, delay: 0.5 }}
              className="md:flex lg:hidden hidden w-full mb-8 items-center justify-center"
            >
              <img
                src={advance_jackpot}
                alt="Grand Jackpot" title='Grand Jackpot'
                className="shadow-lg w-full md:max-w-[30rem] object-cover max-h-[95vh]"
              />
            </motion.div>

            <div className="flex flex-col md:flex-row lg:flex-col md:justify-between md:gap-8 md:max-w-full lg:max-w-[50rem]">
              {["Per Machine Jackpot", "Linked Jackpot"].map((title, index) => (
                <motion.div
                  key={index}
                  initial={{ x: -50, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1, delay: index * 0.3 }}
                >
                  <div className="flex items-center mb-2">
                    <motion.span
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      transition={{ duration: 0.5, delay: index * 0.3 }}
                      className="text-2xl mr-2 mt-[3px]"
                    >
                      <img src={icon_a} alt="" />
                    </motion.span>
                    <h3 className="text-xl font-semibold text-black">{title}</h3>
                  </div>

                  <p className="text-[14px] md:text-[18px] lg:text-base text-gray-500 text-justify poppins-font2 leading-relaxed">
                    {index === 0
                      ? "Each slot machine can have its own individual jackpot system, with Mini, Minor, Major, and Grand levels—fully customizable."
                      : "Connect multiple machines into a shared jackpot pool, boosting prize potential and excitement across all participating terminals."}
                  </p>
                  {/* <p className="text-[14px] md:text-[18px] lg:text-base pt-4 text-gray-500 text-justify poppins-font2 leading-relaxed">
                    These advanced jackpot systems are designed to maximize both player satisfaction and operational flexibility, ensuring a dynamic and rewarding experience for all.
                  </p> */}
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            className="flex md:hidden lg:flex items-center justify-center lg:pt-8 lg:pl-20"
          >
            <img
              src={advance_jackpot}
              alt="Grand Jackpot"
              title='Grand Jackpot'
              className="shadow-lg w-full max-w-full lg:max-w-[42rem] object-cover max-h-[95vh]  sm:mt-0"
            />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default JackpotSystems;
